import { CommonModule } from '@angular/common';
import { Component, computed, Input, signal, ViewChild } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { getDisplayType, StatusEnum } from '@/app/consts/notif.const';
import { DayjsPipe } from '@/app/pipes/dayjs.pipe';
import { SafeHtmlPipe } from '@/app/pipes/safe-html.pipe';

export interface Notification {
  id?: string;
  messageType?: string;
  message?: string;
  title?: string;
  minimal?: boolean;
  startAt?: string;
  expirationAt?: string;
}
@Component({
  selector: 'app-notification-list',
  imports: [TegelModule, CommonModule, DayjsPipe, SafeHtmlPipe],
  standalone: true,
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss'
})
export class NotificationListComponent {
  @Input() emptyMessage = 'No Identified Issues Found.';
  @Input() showEmptyMessage = true;
  @Input() showNotifyPeriod = false;
  @Input() entities = signal<Notification[]>([]);

  @ViewChild('NotificationDetailModal', { static: true })
  delModalRef!: HTMLTdsModalElement;

  currentNotification: Notification = {};
  getDisplayType(status: string): string {
    return getDisplayType(status);
  }

  formattedEntities = computed(() => {
    return this.entities().map(entity => {
      return {
        key: entity.id || entity.message,
        messageType: entity.messageType || StatusEnum.Updates,
        message: entity.message,
        title: entity.title,
        minimal: entity.minimal || false,
        startAt: entity.startAt || '',
        expirationAt: entity.expirationAt || '',
      }
    });
  });

  scrollYPosition: number = 0;
  storeScrollPosition(scrollY: number) {
    this.scrollYPosition = scrollY;
    console.log("🚀 ~ NotificationListComponent ~ storeScrollPosition ~ scrollYPosition:",this.scrollYPosition)
  }

  openDetail(entity: Notification) {
    let parentElement = document.getElementById('NotificationId');
    if (parentElement) {
      const scrollY = parentElement.scrollTop || 0;
      this.storeScrollPosition(scrollY);
    }

    this.currentNotification = {
      ...entity,
      message: entity.message?.replace(/\n/g, '<br/>') || '',
    };
    setTimeout(() => {
      this.delModalRef.showModal();
    }, 0)
  }

  afterClose() {
    let parentElement = document.getElementById('NotificationId');
    if (parentElement) {
      setTimeout(() => {
        document.getElementById('NotificationId')!.scrollTop = this.scrollYPosition - 1 || 0;

      }, 0)
    }
  }
}
